import Link from 'next/link';
import { format, fromUnixTime } from 'date-fns';
import { TournamentListItemFragment } from '@amf/shared/types/graphql';
import classNames from 'classnames';

import { AppLinks } from 'utils/links';

interface TournamentCardProps {
  tournament: TournamentListItemFragment;
}

export default function TournamentCard({ tournament }: TournamentCardProps) {
  const dateStart = fromUnixTime(tournament.dateStart);
  const dateEnd = tournament.dateEnd ? fromUnixTime(tournament.dateEnd) : null;
  return (
    <Link href={`${AppLinks.tournamentList}/${tournament.id}`}>
      <a
        className={classNames('TournamentCard', {
          'TournamentCard--future': !tournament.isStarted,
        })}
      >
        <div className='TournamentCard__content'>
          <div className='TournamentCard__header'>
            <h3 className='TournamentCard__title'>{tournament.name}</h3>
            {tournament.isStarted && <span className='TournamentCard__flag'>Již proběhlo</span>}
          </div>
          <p className='TournamentCard__subtitle'>
            {tournament.year && <span>{tournament.year} | </span>}
            {tournament.category.name} |{' '}
            {dateEnd === null ? (
              <span>{format(dateStart, 'dd/MM/yyyy')}</span>
            ) : (
              <span>
                {format(dateStart, 'dd/MM')} - {format(dateEnd, 'dd/MM/yyyy')}
              </span>
            )}{' '}
            | {tournament.localityName}
          </p>
          <p className='TournamentCard__description'>{tournament.description}</p>
        </div>
      </a>
    </Link>
  );
}
